import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Sun, Sparkles, Trophy } from 'lucide-react';
export function JourneyTimeline() {
  const weeks = [{
    icon: <Sun className="w-6 h-6" data-id="element-190" />,
    week: 'Week 1',
    title: 'Early Signs',
    points: ['Puffiness starts to ease, especially in the morning', 'Digestion feels lighter and more comfortable', '90%+ of users notice less swelling']
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-191" />,
    week: 'Week 2',
    title: 'Visible Changes',
    points: ['Body feels noticeably lighter and less bloated', 'Energy returns without afternoon crashes', 'Brain fog begins to lift']
  }, {
    icon: <Calendar className="w-6 h-6" data-id="element-192" />,
    week: 'Week 3',
    title: 'Transformation',
    points: ['Skin looks clearer and more radiant', 'Mood stabilizes and stress feels manageable', 'Daily comfort and confidence improve']
  }, {
    icon: <Trophy className="w-6 h-6" data-id="element-193" />,
    week: 'Week 4',
    title: 'Lasting Results',
    points: ['Consistent energy throughout the day', 'Flatter-looking body and reduced water weight', 'Lasting balance and vitality']
  }];
  return <section className="py-24 bg-white" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-16" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-197">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-198">
              Your Journey
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-4 mt-2" data-id="element-199">
              Your Lymphatic Reset Journey
            </h2>
            <p className="text-[#374151]" data-id="element-200">
              What to expect when you start LymphoriaX
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-201">
          {weeks.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gradient-to-br from-[#F0FFF4] to-white p-6 rounded-2xl shadow-lg border-2 border-transparent hover:border-[#10B981]/50 transition-all" data-id="element-202">
              <div className="flex items-center space-x-3 mb-4" data-id="element-203">
                <div className="w-12 h-12 rounded-full bg-[#10B981] flex items-center justify-center text-white shadow-lg" data-id="element-204">
                  {item.icon}
                </div>
                <div data-id="element-205">
                  <div className="text-xs font-bold text-[#10B981] uppercase tracking-wider" data-id="element-206">
                    {item.week}
                  </div>
                  <div className="font-bold text-[#1B5E20] text-lg" data-id="element-207">
                    {item.title}
                  </div>
                </div>
              </div>

              <ul className="space-y-3" data-id="element-208">
                {item.points.map((point, i) => <li key={i} className="text-sm text-[#374151] flex items-start" data-id="element-209">
                    <span className="mr-2 text-[#10B981] font-bold" data-id="element-210">✓</span>
                    {point}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}